module.exports = __webpack_public_path__ + "static/img/5.9247a8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newWebSiteImg/pc/cooperation/5.png
// module id = wGvt
// module chunks = 3